export const data = [
    { title: "Champagne (Taste, Best Bottles, Prices 2021)", link: "/blog/champagne" },
    { title: "How to Make a Mimosa (Recipe, Wine Ideas, Serving)", link: "/blog/mimosa" },
    { title: "Easy Sangria Recipes (Tips, Best Wines)", link: "/blog/sangria" },
    {
        title: "Malbec Wine - Winemaking, Best Wines, Prices (2021)",
        link: "/blog/malbec-wine",
    },
    { title: "Sauvignon Blanc (Best Wines, Taste, Prices 2021)", link: "/blog/sauvignon-blanc" },
];
